<script setup lang="ts">
import {
  getAuth,
  onAuthStateChanged,
} from "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import { useUserProfileStore } from "@/store/UserProfile";
import { onMounted, ref, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import AccountCreate from "@/components/AccountCreate.vue";
import AccountLogin from "@/components/AccountLogin.vue";
import AccountStart from "@/components/AccountStart.vue";
import AccountRecoverPassword from "@/components/AccountRecoverPassword.vue";

const auth = getAuth();
const router = useRouter();

const {
  loadRedirectUrlFromCache,
  setVerifyEmail,
  checkSupportAdmin,
} = useUserProfileStore();
const { redirectUrl } = storeToRefs(useUserProfileStore());

const mode = ref<"signIn" | "start" | "createUser" | "recoverPassword">("start");
const username = ref("");
const message = ref("");
const password = ref("");

watch(mode, () => {
  message.value = "";
});

onMounted(async () => {
  await loadRedirectUrlFromCache();
});

onAuthStateChanged(auth, async (user) => {
  if (user) {
    const isNewUser =
      user.metadata?.creationTime === undefined ||
      Date.parse(user.metadata.creationTime) === Date.parse(user.metadata.lastSignInTime);

    if (isNewUser && !user.emailVerified) {
      setVerifyEmail(true);
    } else {
      setVerifyEmail(false);
    }

    checkSupportAdmin();

    if (mode.value !== "createUser") {
      if (redirectUrl.value && redirectUrl.value !== "") {
        router.push(redirectUrl.value);
      } else {
        router.push({
          name:
            "Home"
        });
      }
    }
  }
});
</script>

<template>
  <AppEventContainer>
    <div class="flex flex-col items-center">
      <div class="max-w-[400px]">
        <div class="w-full flex justify-center">
          <img class="p-3 mb-3" src="@/assets/LoginLogo.png" alt="App login logo" />
        </div>
        <AccountStart v-if="mode === 'start'" :username="username"
          @createUser="(x) => { username = x.username; mode = 'createUser'; }"
          @recoverPassword="(x) => { username = x; mode = 'recoverPassword'; }"
          @signIn="(x) => { username = x.username; mode = 'signIn'; }"></AccountStart>
        <AccountLogin v-if="mode === 'signIn'" :username="username" :password="password"
          @createUser="(x) => { username = x.username; password = x.password; mode = 'createUser'; }"
          @recoverPassword="(x) => { username = x; mode = 'recoverPassword'; }" @cancel="mode = 'start'">
        </AccountLogin>
        <AccountCreate v-if="mode === 'createUser'" :username="username" :password="password"
          @recoverPassword="(x) => { mode = 'recoverPassword'; username = x.username; nextTick(() => message = x.message) }"
          @cancel="mode = 'start'"
         >
        </AccountCreate>
        <AccountRecoverPassword v-if="mode === 'recoverPassword'" :username="username" @cancel="mode = 'signIn'"
          :message="message">
        </AccountRecoverPassword>
      </div>
    </div>
  </AppEventContainer>
</template>